import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './EvaluationFormView.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import FooterLanding from '../../components/footerLanding/footerLanding';
import StepCompetencesEvaluation from '../../components/stepCompetencesEvaluation/stepCompetencesEvaluation';
import { apiUrl } from '../../utility/Connections';
import { Layout, message } from 'antd';
import HeaderEvaluation from '../../components/headerEvaluation/headerEvaluation';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';

const { Content } = Layout;

const EvaluationFormView = () => {
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [dataEvaluationAnswerGroups, setDataEvaluationAnswerGroups] = useState([])
    const [evaluationData, setEvaluationData] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);

    const { uuid } = useParams();

    useEffect(() => {
        getEvaluationByUUID(true)
    }, [uuid]);

    const getEvaluationByUUID =  (first) => {
        setLoadingText("Cargando información, espera un momento por favor...")
        setShowLoading(true);
        // Lógica para cargar información con el uuid
        axios.get(`${apiUrl}/evaluation-relationships/get-evaluation-relationship-by-uuid/${uuid}/`)
            .then(function (response) {
                const code = response.data.code;
                if (code == "SUCCESS") {
                    const data = response.data.data;
                    setEvaluationData(data);
                    // setShowLoading(false);
                    if (first) {
                        let stepEncontrado = false
                        if (Array.isArray(data.evr_questions)) {
                            for (let i = 0; i < data.evr_questions.length; i++) {
                                const group = data.evr_questions[i];
                                if (Array.isArray(group.questions)) {
                                    for (let j = 0; j < group.questions.length; j++) {
                                        const q = group.questions[j];
                                        if (q.ean_answer === null || q.ean_answer_text === null) {
                                            if (i > 0) {
                                                setCurrentStep(i + 1); // lo asignas aquí
                                                stepEncontrado = true
                                                break;
                                            } else {
                                                setCurrentStep(0);
                                                stepEncontrado = true
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (stepEncontrado) {
                                    break;
                                }
                                // salir del bucle externo si ya se asignó el paso
                            }
                        }
                        getEvaluationAnswersGroups(data.org_id);
                        getOrganizationLogo(data.org_id);
                    } else {
                        setShowLoading(false);
                    }
                } else if (code == "EVALUATION_ALREADY_FINISHED") {
                    setEvaluationData(null)
                    setShowLoading(false);
                    Swal.fire({
                        title: 'Atención',
                        text: "Esta evaluación ya se encuentra finalizada",
                        icon: 'Success',
                        confirmButtonColor: '#012E40',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const rootUrl = window.location.origin;
                            const link = `${rootUrl}/evaluaciones/listado/${response.data.evl_id}/${response.data.email}`;
                            window.location.href = link;
                        }
                    });
                } 
            })
            .catch(function (error) {
                console.error('There was an error!', error);
            });
    }

    const getEvaluationAnswersGroups = (orgId) => {
        axios.get(`${apiUrl}/evaluation-answer-groups/get-evaluation-answer-groups-org/${orgId}/`)
            .then(function (response) {
                const data = response.data;
                setDataEvaluationAnswerGroups(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const getOrganizationLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const handleAnswerChange = (dimension, ean_dsc_id, newAnswer) => {
        setEvaluationData(prev => {
            const updatedQuestions = prev.evr_questions.map(block => {
                if (block.dimension !== dimension) return block; // ignorar bloques que no coincidan

                const updatedBlockQuestions = block.questions.map(q => {
                    if (q.ean_dsc_id === ean_dsc_id) {
                        return {
                            ...q,
                            ean_answer: newAnswer.value ?? null,
                            ean_answer_text: newAnswer.text ?? newAnswer.value ?? null,
                            ean_saved: true,
                            ean_saved_at: new Date().toISOString()
                        };
                    }
                    return q;
                });

                return {
                    ...block,
                    questions: updatedBlockQuestions
                };
            });

            return {
                ...prev,
                evr_questions: updatedQuestions
            };
        });
    };

    const handleObservationChange = (evl_id, cmp_id, dsc_id, obsText) => {
        setEvaluationData(prev => {
            const updatedObservations = prev.evr_observations.map(obs => {
                if (
                    obs.eob_evl_id === evl_id &&
                    obs.eob_cmp_id === cmp_id &&
                    obs.eob_dsc_id === dsc_id
                ) {
                    return {
                        ...obs,
                        eob_observation: obsText
                    };
                }
                return obs;
            });

            return {
                ...prev,
                evr_observations: updatedObservations
            };
        });
    };

    const saveEvaluationAnswers = (finalize = false, newCurrentStep) => {
        setLoadingText("Guardando respuestas, espera un momento por favor...")
        setShowLoading(true);
        let updatedData = { ...evaluationData };

        if (finalize === true) {
            updatedData.evr_finished = true;
        }
        setCurrentStep(newCurrentStep)

        axios.post(`${apiUrl}/evaluation-relationships/save-evaluation-answers/`, updatedData)
            .then(function (response) {
                getEvaluationByUUID(false)
                if (finalize) {
                    message.success("Evaluación finalizada");
                } else {
                    if (newCurrentStep-1 != 0) {
                        message.success("Respuestas guardadas");
                    }
                }
                
            })
            .catch(error => {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    return <div className='login-view-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Layout style={{ width: "100vw" }}>
            <HeaderEvaluation orgLogo={orgLogo} />
            <Content
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    backgroundColor: 'white',
                    // backgroundColor: '#3E246B',
                    padding: 24,
                    width: "100vw",
                    height: "calc(100vh - 64px)",
                    overflowY: 'auto',
                    position: 'relative',
                }}
            >
                {
                    !showLoading && evaluationData &&
                    <StepCompetencesEvaluation
                        // questions={questionsData}
                        questions={evaluationData?.evr_questions || []}
                        evaluation={evaluationData}
                        dataEvaluationAnswerGroups={dataEvaluationAnswerGroups}
                        onAnswerChange={handleAnswerChange}
                        onObservationChange={handleObservationChange}
                        saveEvaluationAnswers={saveEvaluationAnswers}
                        newCurrentStep={currentStep}
                    />
                }
            </Content>
            <FooterLanding />
        </Layout>
    </div>
}

export default EvaluationFormView;